var module = angular.module('octopusApp.library');

module.directive('retentionSummary', function() {
  return {
    restrict: 'E',
    replace: true,
    template: '<span>{{summary}}</span>',
    scope: {
      policy: "="
    },
    link: function(scope, element) {
      scope.$watch("policy", function() {
        if (!scope.policy) {
          return;
        }

        if (scope.policy.ShouldKeepForever) {
          scope.summary = "Keep all";
        } else if (scope.policy.Unit === "Days") {
          if (scope.policy.QuantityToKeep === 1) {
            scope.summary = "Keep for " + scope.policy.QuantityToKeep + " day";
          } else {
            scope.summary = "Keep for " + scope.policy.QuantityToKeep + " days";
          }
        } else {
          if (scope.policy.QuantityToKeep === 1) {
            scope.summary = "Keep " + scope.policy.QuantityToKeep + " release";
          } else {
            scope.summary = "Keep " + scope.policy.QuantityToKeep + " releases";
          }
        }
      });
    }
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/lifecycles/directives/retention_summary.js
// module id = 2064213424313267
// module chunks = 1